module.exports = __webpack_public_path__ + "assets/img/step2-1.4d61b13e.png";